import { render, staticRenderFns } from "./AcademicMajorScore.vue?vue&type=template&id=57f20480"
import script from "./AcademicMajorScore.vue?vue&type=script&lang=js"
export * from "./AcademicMajorScore.vue?vue&type=script&lang=js"
import style0 from "./AcademicMajorScore.vue?vue&type=style&index=0&id=57f20480&prod&lang=less"
import style1 from "./AcademicMajorScore.vue?vue&type=style&index=1&id=57f20480&prod&scope=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports